import * as React from 'react';
import createIconComponent from '../createIconComponent.js';

var l = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", fill: "none", viewBox: "0 0 32 32" },
    React.createElement("path", { fill: "#101010", fillRule: "evenodd", d: "M16 6.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5M11.75 12a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0M16 19.25c-2.992 0-5.822.701-8.334 1.95l-.416.206v4.344h17.5v-4.344l-.416-.207A18.7 18.7 0 0 0 16 19.25m-7.25 5v-1.907A17.2 17.2 0 0 1 16 20.75c2.59 0 5.047.57 7.25 1.593v1.907z", clipRule: "evenodd" })));
var Profile = createIconComponent({ l: l });

export { Profile as default };
//# sourceMappingURL=Profile.js.map
